import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../components/ToastMsg";
import "react-loading-skeleton/dist/skeleton.css";
import styles from './index.module.css';
import TableSkeleton from "../../../../components/Skeleton";
import NoResultsFound from "../../../../components/NoResultsFound";
import Modal from "../../../../components/Modal";
import { faCircleCheck, faCircleXmark, faDownload, faPen, faXmark } from "@fortawesome/free-solid-svg-icons";
import { editCertificate, editCertificateBulkStatus, editCertificateVersion, getAllCertificates, getAllCertificatesToBulkDownload } from "../../../../redux/features/certificate/certificateService";
import { getAllActiveCourses } from "../../../../redux/features/course/courseService";
import FilterDropdown from "../../../../components/FilterDropdown";
import SearchBarRow from "../../../../components/SearchBarRow";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import QRCode from "qrcode";
import BeatLoader from "react-spinners/BeatLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parse } from "date-fns";
import { useNavigate } from "react-router-dom";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { selectActiveCertificateList } from "../../../../redux/features/certificateEntity/certificateEntitySlice";
import { selectActiveCertificateTypesList } from "../../../../redux/features/certificateType/certificateTypeSlice";
import { getActiveCertificateTypes } from "../../../../redux/features/certificateType/certificateTypeService";
import { getCertificateTemplatesByType } from "../../../../redux/features/certificateTemplate/certificateTemplateService";
import IBSUOfficialCertificate from "../../../../components/Certificate/IBSUCertificate/IBSUOfficial";
import IBSCOfficialCertificate from "../../../../components/Certificate/IBSCCertificate/IBSCOfficial";
import CDCCertificate from "../../../../components/Certificate/CDCCertificate/CDCOther";
import { LuLogs } from "react-icons/lu";
import { LuPrinterCheck } from "react-icons/lu";
import { faEye } from "@fortawesome/free-regular-svg-icons";

const QR_Link = process.env.REACT_APP_PUBLIC_QR_LINK;

const certificateStatus = [
    { id: '1', name: 'Pending' },
    { id: '2', name: 'Verified' },
    { id: '3', name: 'Printed' },
    { id: '4', name: 'Issued' },
    { id: '5', name: 'ReIssued' },
    { id: '6', name: 'Cancelled' }
];

const limitSize = [
    { index: 0, name: '10', value: 10 },
    { index: 1, name: '20', value: 20 },
    { index: 2, name: '50', value: 50 },
    { index: 3, name: '100', value: 100 },
    { index: 4, name: 'Unlimited', value: 1 },
];

const convertToDate = (dateString) => {
    // Remove ordinal suffixes (st, nd, rd, th)
    const cleanedDate = dateString.replace(/(\d+)(st|nd|rd|th)/, "$1");

    // Convert string to Date object
    return parse(cleanedDate, "d MMMM yyyy", new Date());
};

const CertificateList = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const entityDropdownRef = useRef(null);
    const courseDropdownRef = useRef(null);
    const typeDropdownRef = useRef(null);
    const templateDropdownRef = useRef(null);
    const statusDropdownRef = useRef(null);

    const { isCertificatesLoading, certificates } = useSelector((state) => state.certificate.allCertificates);
    const { isEditingCertificate } = useSelector((state) => state.certificate.editedCertificate);
    const { data: certificateTypes } = useSelector(selectActiveCertificateTypesList);
    const { activeCourses } = useSelector((state) => state.course.allActiveCourses);

    const [searchQuery, setSearchQuery] = useState('');

    const [selectedCourse, setSelectedCourse] = useState({
        id: '',
        name: ''
    });
    const [selectedStatus, setSelectedStatus] = useState({
        id: '',
        name: ''
    });
    const [currentPage, setCurrentPage] = useState(1);

    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedCertificate, setSelectedCertificate] = useState(null);
    const [initialCertificate, setInitialCertificate] = useState(null);
    const [editErrorMsgs, setEditErrorMsgs] = useState({
        name: '',
        course_code: ''
    });
    const [disabledEditBtn, setEditBtnDisable] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);

    const [completionDate, setCompleteDate] = useState(new Date());
    const [certificateDate, setCertificateDate] = useState(new Date());
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [pageLimit, setPageLimit] = useState(10);

    const [certificateTemplates, setCertificateTemplates] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState({
        id: '',
        name: ''
    });
    const [selectedType, setSelectedType] = useState({
        id: '',
        name: ''
    });
    const [selectedTemplate, setSelectedTemplate] = useState({
        id: '',
        name: ''
    });

    const [templateLoadng, setTemplateLoading] = useState(false);
    const [batch, setBatch] = useState('');

    const fetchDetails = useCallback(() => {
        dispatch(getAllActiveCourses());
        dispatch(getActiveCertificateTypes());
    }, [dispatch]);

    useEffect(() => {
        fetchDetails();
    }, [fetchDetails]);

    const handleSelect = (option) => {
        setSelectedCourse({
            id: option.id,
            name: option.name
        });
    };

    const handleType = async (option) => {
        setTemplateLoading(true);
        setCertificateTemplates([]);
        setSelectedTemplate({ id: '', name: '' })
        setSelectedType({
            id: option.id,
            name: option.name,
        });
        const response = await dispatch(getCertificateTemplatesByType({ id: option.id })).unwrap();
        setCertificateTemplates(response);
        setTemplateLoading(false);
    };

    const handleTemplate = (option) => {
        setSelectedTemplate({
            id: option.id,
            name: option.name
        });
    };

    const fetchAllCertificates = useCallback(
        (filters = {}) => {
            const params = {
                search: searchQuery,
                course_id: selectedCourse.id,
                ...(pageLimit !== 1 && { skip: (currentPage - 1) }),
                limit: pageLimit,
                status: selectedStatus.name,
                certificate_entity_id: selectedEntity.id,
                batch: batch,
                certificate_type_id: selectedType.id,
                certificate_template_id: selectedTemplate.id,
                ...filters,
            };
            dispatch(getAllCertificates(params));
        },
        [dispatch, searchQuery, selectedStatus, selectedEntity, selectedCourse, currentPage, pageLimit, batch, selectedType, selectedTemplate]
    );

    useEffect(() => {
        fetchAllCertificates();
    }, [fetchAllCertificates]);

    const handleSelectStatus = (option) => {
        setSelectedStatus({
            id: option.id,
            name: option.name
        });
        setCurrentPage(1);
    };

    const previewCertificate = (certificate) => {
        const url = `/issuer/certificates/preview-certificate/${certificate.id}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    // Edit certificate
    const handleSelectedCertificateChange = (e) => {
        const { name, value } = e.target;
        setErrorMsg(null);
        setSelectedCertificate((prev) => ({
            ...prev,
            [name]: value,
        }));

        setEditErrorMsgs((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const isValidEditCertificate = () => {
        const errors = {};
        const trimmedName = selectedCertificate.student_name.trim();

        if (!trimmedName) {
            errors.student_name = "Name is required.";
        }
        if (Object.keys(errors).length > 0) {
            setEditErrorMsgs(errors);
            return false;
        } else {
            return true;
        }
    };

    function getChangedValues(selectedData, completeDate, certificateDate) {
        const changedValues = {};
        const keysToCheck = ['student_name', 'completion_date', 'issued_date', 'certificate_status'];

        for (const key of keysToCheck) {
            let newValue = selectedData[key];

            // Use the provided completeDate and certificateDate if checking these fields
            if (key === 'completion_date' && completeDate !== initialCertificate[key]) {
                changedValues[key] = completeDate;
            } if (key === 'issued_date' && certificateDate !== initialCertificate[key]) {
                changedValues[key] = certificateDate;
            } if (key === 'student_name' && newValue !== initialCertificate[key]) {
                changedValues[key] = newValue;
            }
        }

        // Ensure `id` is always included
        if (selectedData.id) {
            changedValues.id = selectedData.id;
        }

        return changedValues;
    }

    const formatDateWithSuffix = (date) => {
        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "long" });
        const year = date.getFullYear();

        // Function to add ordinal suffix
        const getOrdinalSuffix = (num) => {
            if (num > 3 && num < 21) return "th"; // 11th, 12th, 13th...
            switch (num % 10) {
                case 1: return "st"; // 1st
                case 2: return "nd"; // 2nd
                case 3: return "rd"; // 3rd
                default: return "th"; // 4th, 5th, 6th...
            }
        };

        return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
    };

    const editCertificateDetails = async () => {
        const completeData = formatDateWithSuffix(completionDate);
        if (selectedCertificate.completion_date !== completeData) {
            setSelectedCertificate(prevState => ({
                ...prevState,
                completion_date: completeData
            }));
        }
        const certificateData = formatDateWithSuffix(certificateDate);
        if (selectedCertificate.issued_date !== certificateData) {
            setSelectedCertificate(prevState => ({
                ...prevState,
                issued_date: certificateData
            }));
        }
        if (isValidEditCertificate(selectedCertificate.student_name)) {
            const data = getChangedValues(selectedCertificate, completeData, certificateData);
            const hasChanges = Object.keys(data).some(key => key !== 'id');
            if (!hasChanges) {
                setErrorMsg('There are no changes to update.');
            } else {
                setEditBtnDisable(true);
                try {
                    const response = await dispatch(editCertificate(data)).unwrap();
                    setEditBtnDisable(false);
                    setSelectedCertificate(null);
                    setInitialCertificate(null);
                    setModalOpen(false);
                    showToast('success', response.message);
                    fetchAllCertificates();
                }
                catch (error) {
                    setEditBtnDisable(false);
                    showToast('error', error.message);
                };
            }
        }
    };

    //Certificate status
    const [printModalOpen, setPrintModalOpen] = useState(false);

    const handleClearFilters = () => {
        if (statusDropdownRef.current) {
            statusDropdownRef.current.clearSelection();
        }
        if (entityDropdownRef.current) {
            entityDropdownRef.current.clearSelection();
        }
        if (courseDropdownRef.current) {
            courseDropdownRef.current.clearSelection();
        }
        if (typeDropdownRef.current) {
            typeDropdownRef.current.clearSelection();
        }
        if (templateDropdownRef.current) {
            templateDropdownRef.current.clearSelection();
        }
        setSelectedStatus({ id: '', name: '' });
        setSelectedEntity({ id: '', name: '' });
        setSelectedCourse({ id: '', name: '' });
        setSelectedType({ id: '', name: '' });
        setSelectedTemplate({ id: '', name: '' });
        setSearchQuery("");
    };

    const handleLimit = async (option) => {
        setPageLimit(option);
    };

    return (
        <>
            <div className={`search-card`}>
                <div className={`search-card-header`}>
                    <h1 className={`form-title`}>Certificate List</h1>
                </div>
                <div className={styles.searchSec}>
                    <div className={`form-input-row ${styles.rowFullWidth}`}>
                        <div className={`form-input-group`}>
                            <FilterDropdown
                                ref={statusDropdownRef}
                                options={certificateStatus}
                                placeholder="Choose a Status"
                                onSelect={handleSelectStatus}
                                value={selectedStatus.name}
                            />
                        </div>
                        <div className={`form-input-group`}>
                            <SearchBarRow onSearch={(query) => setSearchQuery(query)} />
                        </div>
                        {/* <div className={styles.clearButton} onClick={handleClearFilters}>
                            <FontAwesomeIcon icon={faCircleXmark} /> <span>Clear All</span>
                        </div> */}
                    </div>
                </div>
                <div className={styles.searchSec}>
                    <div className={`form-input-row ${styles.rowFullWidth}`}>
                        <div className={`form-input-group`}>
                            <FilterDropdown
                                ref={typeDropdownRef}
                                options={certificateTypes}
                                placeholder='Select a Type'
                                onSelect={handleType}
                                value={selectedType.name}
                            /></div>
                        <div className={`form-input-group`}>
                            {selectedType.id !== '' && !templateLoadng && <FilterDropdown
                                ref={templateDropdownRef}
                                options={certificateTemplates}
                                placeholder='Select a Template'
                                onSelect={handleTemplate}
                                value={selectedTemplate.name}
                            />}
                        </div>
                    </div>
                </div>
                {selectedType?.name === 'OFFICIAL' && <div className={styles.searchSec}>
                    <div className={`form-input-row ${styles.rowFullWidth}`}>
                        <div className={`form-input-col md-col`}>
                            <FilterDropdown
                                ref={courseDropdownRef}
                                options={activeCourses}
                                placeholder="Select a Course"
                                onSelect={handleSelect}
                                value={selectedCourse.name}
                            />
                        </div>
                    </div>
                </div>}
                <div className={`form-input-row ${styles.rowFullWidth}`}>
                    <div className={`form-input-col md-col ${styles.rightCol}`}>
                        <div className={`form-input-group`}>
                            {certificates.length > 0 &&
                                <div className={styles.btnGroup}>
                                    {limitSize.map((limit) => (
                                        <div key={limit.index} className={pageLimit === limit.value ? styles.activeBtn : styles.limitBtn} onClick={() => handleLimit(limit.value)}>{limit.name}</div>
                                    ))}
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={`search-card-body`}>
                    {isCertificatesLoading ?
                        <TableSkeleton columns={["Document Ref", "Student Id", "Name", "Course", "Status", "Batch", "Actions"]} rowCount={10} height={20} />
                        : certificates.length > 0 ?
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Document Ref</th>
                                            <th>Student Id</th>
                                            <th>Name</th>
                                            <th>Course</th>
                                            <th>Status</th>
                                            <th>Batch</th>
                                            <th style={{ paddingLeft: '10px' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {certificates?.map((certificate) => (
                                            <tr key={certificate.id} className={selectedRows.includes(certificate.id) ? `${styles.selectedRow}` : ''}>
                                                <td className={`tdataColumnOne`}>
                                                    {certificate?.document_ref}
                                                </td>
                                                <td>
                                                    {certificate?.student?.student_id}
                                                </td>
                                                <td>
                                                    {certificate?.student_name}
                                                </td>
                                                <td>
                                                    {certificate?.course_batch?.course?.name || certificate?.other_course}
                                                </td>
                                                <td>{certificate?.certificate_status}</td>
                                                <td>{certificate?.batch ? certificate?.batch : certificate?.course_batch?.name || certificate?.certificate_entity_batch?.name || '-'}</td>
                                                <td className={`actionsBtn ${styles.tableBtnSec}`} style={{ paddingLeft: '10px' }}>
                                                    <button className={`btn-edit-label`} onClick={() => previewCertificate(certificate)}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </button>
                                                    {['Pending'].includes(certificate?.certificate_status) &&
                                                        <button className={`btn-edit-primary`} onClick={() => {
                                                            setSelectedCertificate(certificate);
                                                            setInitialCertificate(certificate);
                                                            setEditBtnDisable(false);
                                                            setErrorMsg(null);
                                                            setEditErrorMsgs({
                                                                name: '',
                                                                course_code: ''
                                                            })
                                                            setModalOpen(true);
                                                        }}><FontAwesomeIcon icon={faPen} /></button>

                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <NoResultsFound />
                    }
                </div>
                {isModalOpen &&
                    <div className={`modal-overlay`}>
                        <div className={`modal-card`}>
                            <div className={`modal-header`}>
                                <h4 className={`modal-title`}>Edit Certificate Details</h4>
                                <FontAwesomeIcon icon={faXmark} onClick={() => setModalOpen(false)} size="lg" cursor="pointer" />
                            </div>
                            <div className={`modal-body`}>
                                <div className={styles.formContainer}>
                                    <form
                                        className={styles.coordinatorForm}
                                        noValidate
                                    >
                                        <div className={`form-input-row md-col`}>
                                            <div className={`form-input-group`}>
                                                <label htmlFor='full_name' className={`form-label`}>
                                                    Document Ref<span className={`required-star`}>*</span>
                                                </label>
                                                <input
                                                    type='text'
                                                    id='document_ref'
                                                    name='document_ref'
                                                    value={selectedCertificate.document_ref || ''}
                                                    placeholder='Enter tudent Name'
                                                    className={`form-input-default`}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className={`form-input-row md-col`}>
                                            <div className={`form-input-group`}>
                                                <label htmlFor='full_name' className={`form-label`}>
                                                    Student Name<span className={`required-star`}>*</span>
                                                </label>
                                                <input
                                                    type='text'
                                                    id='student_name'
                                                    name='student_name'
                                                    value={selectedCertificate.student_name || ''}
                                                    onChange={handleSelectedCertificateChange}
                                                    placeholder='Enter Student Name'
                                                    className={`form-input-default`}
                                                />
                                                {editErrorMsgs.student_name && (
                                                    <p className={`text-danger`}>{editErrorMsgs.student_name}</p>
                                                )}
                                            </div>
                                        </div>
                                        {/* <div className={`form-input-row md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Completion Date<span className={`required-star`}>*</span>
                                            </label> */}
                                        {/* <DatePicker
                                                selected={completionDate}
                                                onChange={(date) => {
                                                    setCompleteDate(date);
                                                    setErrorMsg(null);
                                                }}
                                                className={styles.dateSelector} /> */}
                                        {/* <input
                                                type='text'
                                                id='completion_date'
                                                name='completion_date'
                                                value={selectedCertificate.completion_date || ''}
                                                onChange={handleSelectedCertificateChange}
                                                placeholder='Enter Completion Date'
                                                className={`form-input-default`}
                                            /> */}
                                        {/* </div>
                                    </div> */}
                                        <div className={`form-input-row md-col`}>
                                            <div className={`form-input-group`}>
                                                <label htmlFor='full_name' className={`form-label`}>
                                                    Issued Date<span className={`required-star`}>*</span>
                                                </label>
                                                <DatePicker
                                                    selected={certificateDate}
                                                    onChange={(date) => {
                                                        setCertificateDate(date);
                                                        setErrorMsg(null);
                                                    }}
                                                    className={styles.dateSelector} />
                                                {errorMsg && (
                                                    <p className={`text-danger`}>{errorMsg}</p>
                                                )}
                                            </div>
                                        </div>
                                        <button
                                            className={`btn-primary`}
                                            type='button'
                                            disabled={disabledEditBtn}
                                            onClick={editCertificateDetails}
                                        >
                                            {isEditingCertificate ? <BeatLoader color='#ffffff' /> : `Save`}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div >
            {/* <PDFViewer width={800} height={1400}>
                <CDCCertificate data={[certificates[0], 'qrDataUrl']} />
            </PDFViewer> */}
        </>
    );
};

export default CertificateList;
